import React, { type HtmlHTMLAttributes } from 'react';
import styled, { css } from 'styled-components';
import { ColorBrandBlue1, ColorNeutralWhite, Spacing4, Spacing8 } from 'autogen/design-tokens/tokens';
import getTypeStyling from 'helpers/getTypeStyling';
import Label from '../typography/components/Label';
import type { BadgeSizes, IBadge } from './shared/types';

const badgeSizes = {
    small: css`
        height: 20px;
        width: 20px;
        padding: ${Spacing4};
    `,
    medium: css`
        height: 24px;
        width: 24px;
        padding: ${Spacing4};
    `,
    large: css`
        height: 26px;
        width: 26px;
        padding: ${Spacing8};
    `
};

const BadgeComponent = styled.div<{ size: IBadge['size'] }>`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: ${ColorNeutralWhite};
    background-color: ${ColorBrandBlue1};

    // size
    ${badgeSizes.small}
    ${({ size }) => size && getTypeStyling((resolvedSize: BadgeSizes) => badgeSizes[resolvedSize])(size as BadgeSizes)}
`;

const StyledLabel = styled(Label)`
    line-height: normal;
`;

const Badge = React.forwardRef<HTMLDivElement, HtmlHTMLAttributes<HTMLDivElement> & IBadge>(
    ({ children, size = { md: 'medium', lg: 'large' }, ...restProps }, ref) => (
        <BadgeComponent ref={ref} size={size} {...restProps}>
            <StyledLabel size="XS">{children}</StyledLabel>
        </BadgeComponent>
    )
);

export default Badge;
